import { useTimer as useTime } from 'use-timer';

const useTimer = (timer: number, setModal: (value: string) => void) => {
  const { time, pause } = useTime({
    initialTime: timer,
    endTime: 0,
    autostart: true,
    timerType: 'DECREMENTAL',
    onTimeOver: () => {
      setModal('timeIsUp');
    },
  });

  return { time, pause };
};

export { useTimer };
